import script from "./ckHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ckHeader.vue?vue&type=script&setup=true&lang=js"

import "./ckHeader.vue?vue&type=style&index=0&id=8952de1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8952de1c"]])

export default __exports__